export class HealthSeverity {
	/**
	 * Condition-specific severity instances ordered by descending score (higher = more severe).
	 * Scores encode the relative ordering per the device health specification:
	 *
	 * 204 overTemperature         – Critical: permanent device damage possible
	 * 203 batteryLevelCritical    – Critical: critical device failure imminent
	 * 202 licenseActivationFailed – Critical: device not operational as intended
	 * 201 rfInterference          – Critical: critical performance metric
	 * 104 missing                 – Warning:  monitoring not possible
	 * 103 firmwareIncompatible    – Warning:  monitoring not possible
	 * 102 batteryLevelWarning     – Warning:  device operational failure possible
	 * 101 licenseOwnershipMismatch– Warning:  changing licenses not possible
	 */
	public static readonly overTemperature = new HealthSeverity('CRITICAL', 204);
	public static readonly batteryLevelCritical = new HealthSeverity('CRITICAL', 203);
	public static readonly licenseActivationFailed = new HealthSeverity('CRITICAL', 202);
	public static readonly rfInterference = new HealthSeverity('CRITICAL', 201);
	public static readonly critical = new HealthSeverity('CRITICAL', 200);
	public static readonly missing = new HealthSeverity('WARNING', 104);
	public static readonly firmwareIncompatible = new HealthSeverity('WARNING', 103);
	public static readonly batteryLevelWarning = new HealthSeverity('WARNING', 102);
	public static readonly licenseOwnershipMismatch = new HealthSeverity('WARNING', 101);
	public static readonly warning = new HealthSeverity('WARNING', 100);
	public static readonly unknown = new HealthSeverity('UNKNOWN', -1);

	/**
	 * The unique severity value, e.g. 'CRITICAL'
	 */
	public readonly value;

	/**
	 * The relative severity, with higher scores meaning worse severity.
	 */
	public readonly score;

	protected constructor(value: string, score: number) {
		this.value = value;
		this.score = score;
	}

	public static fromValue(value?: string): HealthSeverity {
		switch (value) {
			case 'CRITICAL': {
				return HealthSeverity.critical;
			}
			case 'WARNING': {
				return HealthSeverity.warning;
			}
			default: {
				return HealthSeverity.unknown;
			}
		}
	}

	public toString(): string {
		return this.value;
	}

	public worseThan(other: HealthSeverity): boolean {
		return this.score > other.score;
	}
}
